export enum INVITATION_STATUSES {
  CREATED = 'Created',
  ACCEPTED = 'Accepted',
  DECLINED = 'Declined',
}
